import { addRequestInterceptor } from '@ht-lib/accounts-api-client'
import { getDefaultAuth, initializeCompat } from '@ht-web/firebase-adapter'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import config from '../config'

export const app = initializeCompat({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
})

export const auth = getDefaultAuth()

addRequestInterceptor(async requestConfig => {
  // Do something before request is sent
  try {
    requestConfig.baseURL = config.baseURL
    if (requestConfig.url?.startsWith('/') === true) {
      const idToken = await auth.currentUser?.getIdToken() ?? ''
      if (requestConfig.headers == null) { requestConfig.headers = {} }
      requestConfig.headers.Authorization = 'Bearer ' + idToken
    }
    return requestConfig
  } catch (error) {
    console.error(error)
    return await Promise.reject(error)
  }
}, async (error) => {
  // Do something with request error
  console.error(error)
  return await Promise.reject(error)
}).catch(console.error)
